/**
 * @module store/points/actions
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetPoints, apiSetPoint, apiDeletePoint } from '@/api';
import * as types from '@/store/mutation-types';


/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const getPoints = async ({ commit, rootGetters }) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const points = await apiGetPoints(userSession.accessToken.jwtToken);
      commit(types.SET_POINTS, points);
    } else {
      throw new Error('Неавторизованный пользователь не может плучать информацию о точках.');
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Action: Set point
 *
 * @since Version 1.0.3
 */
const setPoint = async ({ dispatch, rootGetters }, point) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetPoint(userSession.accessToken.jwtToken, point);
      await dispatch('getPoints');
    } else {
      throw new Error('Неавторизованный пользователь не может менять информацию об акциях.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


/**
 * Action: Delete point
 *
 * @since Version 1.0.3
 */
const deletePoint = async ({ dispatch, rootGetters }, id) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiDeletePoint(userSession.accessToken.jwtToken, id);
      await dispatch('getPoints');
    } else {
      throw new Error('Неавторизованный пользователь не может удалять информацию об акциях.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


export default {
  deletePoint,
  getPoints,
  setPoint,
};
